// boot/utils.js
export const isNovoCadastro = (uuid) => !(uuid && uuid !== 'null');

export const mergeIfEmpty = (prev, patch) => {
    const out = { ...prev };
    let changed = false;

    Object.keys(patch || {}).forEach((k) => {
        const prevVal = prev?.[k];
        const nextVal = patch[k];

        const empty = prevVal === undefined || prevVal === null || prevVal === '' || (Array.isArray(prevVal) && prevVal.length === 0);

        if (empty && nextVal !== undefined) {
            out[k] = nextVal;
            changed = true;
        }
    });

    return changed ? out : prev;
};

export const mergeAlways = (prev, patch) => {
    // Se o patch não existe, retorna o original
    if (!patch) return prev;

    const isObject = (obj) => obj && typeof obj === 'object' && !Array.isArray(obj);

    const out = { ...prev };

    Object.keys(patch).forEach((key) => {
        const patchValue = patch[key];
        const prevValue = prev?.[key];

        if (isObject(patchValue) && isObject(prevValue)) {
            // Se ambos são objetos, entra na recursão
            out[key] = mergeAlways(prevValue, patchValue);
        } else {
            // Se for valor primitivo ou array, substitui
            out[key] = patchValue;
        }
    });

    return out;
};
